module.exports = __webpack_public_path__ + "static/media/Gastro-Patient-Intake-1@3x.322411a3.png";